



























































import Vue from 'vue'
import KeyFeaturesMixin from './KeyFeaturesMixin.vue'
import { chunk } from '~/utils/array'

export default Vue.extend({
  mixins: [KeyFeaturesMixin],
  computed: {
    keyFeaturesColumns() {
      return chunk(this.keyFeatures, 3)
    }
  }
})
